/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Row, Column, TrackingList } from '../../tracking-list';
import { SurveyQuestionListProps } from '../survey-question-list';
import { QUESTION } from '../../../constants/terminology';

type QuestionListEmptyProps = Pick<SurveyQuestionListProps, 'noRowsMessage' | 'handleNoRows'>;

export const QuestionListEmpty = (props: QuestionListEmptyProps) => {
  const { noRowsMessage, handleNoRows } = props;

  const message = noRowsMessage || `No ${QUESTION.PLURAL} have been selected`;
  const noRowsHandler = handleNoRows || undefined;
  return (
    <TrackingList className='mt-3'>
      <Row>
        <Column stretch onClick={noRowsHandler} className='text-center'>{message}</Column>
      </Row>
    </TrackingList>
  );
}
